/* ===== VELANTIS · Preventa v5 (10-sep-2026) =====
   Un solo aparato para dos lugares:
     · en la landing, el deck de casas sustituye al bloque de preventa que habia;
     · en #/preventa, el mismo deck es el heroe y debajo va el catalogo de las veinte,
       con la tarjeta del sitio y un buscador flotante.
   Los precios y las variantes salen del mapa vivo, no de una copia, y el carrito es el
   del sitio: ahi viven las promociones y se aplican solas al agregar. */
(function(){
  var raiz = document.getElementById('pv5'), asomo = document.getElementById('pv5t');
  if(!raiz && !asomo) return;
  var CFG, ESC, FOTOS = {}, P, LLEGA, cur = null, talla = null, obs = null;
  var MES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  var jsonCache61=new WeakMap();
  function json(id){var n=document.getElementById(id);if(!n)return null;var text=n.textContent,old=jsonCache61.get(n);if(old&&old.text===text)return old.data;
    try{var data=JSON.parse(text);jsonCache61.set(n,{text:text,data:data});return data;}catch(e){return null;}}
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function pesos(n){ return '$' + Number(n).toLocaleString('es-MX'); }
  function plano(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }

  /* --- el mapa vivo: precio y variante de hoy --- */
  function mapa(){ return json('pc-conexion') || {}; }
  function precio(ruta, t, base){
    var m = mapa(), p = (t === '50' ? m.precios50 : m.precios) || {};
    var v = p[ruta]; return (v == null ? base : Math.round(v));
  }
  function hayVariante(ruta, t){
    var m = mapa(), v = (t === '50' ? m.variantes50 : m.variantes) || {};
    if(v[ruta]) return true;
    /* El mapa vivo se hornea con la portada y no trae las altas recientes: sin esto, un
       lanzamiento de ayer se quedaba sin su pastilla de 50 ml (la casa, 16-sep). El carrito
       ya carga la copia al día del tema, así que se le pregunta a él. */
    try{ return !!(window.VelantisCart && window.VelantisCart.variante && window.VelantisCart.variante(ruta, t)); }
    catch(e){ return false; }
  }
  function familia(ruta){
    var C = window.VELANTIS_CAT || [], u = String(ruta || '').toUpperCase();
    for(var i = 0; i < C.length; i++) if(String(C[i][0]).toUpperCase() === u) return C[i][9] || 'amaderados';
    return 'amaderados';
  }
  function datos(){
    if(CFG) return true;
    CFG = json('pv5-cfg'); ESC = json('pv5-escenas') || {}; FOTOS = json('pv5-fotos') || {};
    if(!CFG) return false;
    P = CFG.llegada.split('-');
    LLEGA = new Date(+P[0], +P[1] - 1, +P[2], 0, 0, 0);
    return true;
  }
  function porSku(sku){
    for(var i = 0; i < CFG.piezas.length; i++) if(CFG.piezas[i].sku === sku) return CFG.piezas[i];
    return null;
  }

  /* ------------------------------------------------------------- el reloj
     Corre hasta las once de la mañana del dia de la llegada, que es cuando abre
     Colosio 315. Un solo intervalo para los relojes que haya en la pagina. */
  var relojes = [], relojero = null;
  function reloj(nodo, titulo){
    if(!nodo) return;
    relojes.push({n: nodo, t: titulo});
    if(!relojero) relojero = setInterval(pintaRelojes, 1000);
    pintaRelojes();
  }
  function pintaRelojes(){
    var meta = new Date(+P[0], +P[1] - 1, +P[2], 11, 0, 0), falta = meta - new Date();
    var C = CFG.comercial.seccion, dos = function(n){ return n < 10 ? '0' + n : '' + n; };
    var html, tit = null;
    if(falta > 0){
      var seg = Math.floor(falta / 1000);
      html = '<div class="pv5-reloj">' +
        '<u><b>' + Math.floor(seg / 86400) + '</b><i>días</i></u>' +
        '<u><b>' + dos(Math.floor(seg % 86400 / 3600)) + '</b><i>hrs</i></u>' +
        '<u><b>' + dos(Math.floor(seg % 3600 / 60)) + '</b><i>min</i></u>' +
        '<u><b>' + dos(seg % 60) + '</b><i>seg</i></u>' +
        '<span class="pv5-relojpie">' + esc((CFG.comercial.asomo.reloj) || 'para apartar') + '</span></div>';
    }else{
      var hoy = new Date(); hoy.setHours(0,0,0,0);
      var m0 = new Date(+P[0], +P[1] - 1, +P[2]);
      if(hoy.getTime() === m0.getTime()){ html = '<span class="q">Entregas hoy &middot; Colosio 315</span>'; tit = C.tituloHoy; }
      else { html = '<span class="q">Entregados del ' + (+P[2]) + ' al ' + ((+P[2]) + 2) + ' de ' + MES[+P[1]-1] + '</span>'; tit = C.tituloPaso; }
      clearInterval(relojero); relojero = null;
    }
    relojes.forEach(function(r){
      r.n.innerHTML = html;
      if(tit && r.t) r.t.innerHTML = tit;
    });
  }

  function imagenProducto(x){
    var src=FOTOS[x.sku]||ESC[x.sku]||'';
    function sized(width){try{var u=new URL(src,location.href);u.searchParams.set('width',width);return u.href;}catch(e){return src;}}
    return '<img src="'+esc(sized(480))+'" srcset="'+esc(sized(240))+' 240w, '+esc(sized(480))+' 480w, '+esc(sized(720))+' 720w" sizes="(max-width:767px) 240px, 320px" width="720" height="720" alt="Velantis inspirado en '+esc(x.nombre)+'" loading="lazy" decoding="async">';
  }

  /* ------------------------------------------------------------- el deck */
  function compraDeck(x){
    var ops=['50','100'].filter(function(t){return hayVariante(x.ruta,t);});
    if(!ops.length)return '';
    var selected=ops.indexOf('100')>=0?'100':ops[0];
    return '<div class="pv5-p-compra"><div class="preTallas" role="group" aria-label="Presentación">'+ops.map(function(t){return '<button type="button" class="preTalla pz'+(t===selected?' pz-sel':'')+'" aria-pressed="'+(t===selected)+'" data-addt="'+esc(x.sku)+'|'+t+'"><span>'+t+' ml</span><strong>'+pesos(precio(x.ruta,t,t==='50'?x.p50:x.p100))+'</strong></button>';}).join('')+'</div><button class="preAgregar" type="button" data-add="'+esc(x.sku)+'">Agregar al carrito</button></div>';
  }
  function fichaDeck(c, x){
    var ella = (x.cat === 'Para ella') && c.femenino;
    return '<article class="pv5-p' + (ella ? ' ella' : '') + '" data-sku="' + esc(x.sku) + '" data-tl-sel="' + (hayVariante(x.ruta, '100') ? '100' : '50') + '"' +
      (ella && !c.solo_ella ? ' style="--c:' + c.femenino + '"' : '') + '>' +
      '<span class="pv5-p-esc">' + imagenProducto(x) + '' +
      '</span>' +
      '<button class="pv5-p-t" type="button" data-ver="' + esc(x.sku) + '">' +
        '<span class="pv5-p-ins">Inspirado en</span>' +
        '<span class="pv5-p-nom">' + esc(x.nombre) + '</span>' +
        '<span class="pv5-p-de">de ' + esc(c.casa) + ' &middot; ' + esc(x.cat) + '</span>' +
        '<span class="pv5-p-fam">' + esc(x.grupo) + '</span>' +
        '<span class="pv5-p-olor">' + esc(x.olor) + '</span>' +
        '<span class="pv5-p-rel">' + esc(x.relato) + '</span>' +
      '</button>' + compraDeck(x) + '</article>';
  }

  /* Las casas, apiladas a lo alto y cada una con su tira horizontal. Se llamaba
     `deckHTML` y hacia una diapositiva de pantalla completa por casa; era un hero y se
     comia la pagina. Ahora es una banda por casa, como estaba planeado. */
  function pilaHTML(){
    var pref = 's';
    var bandas = CFG.casasSeccion.map(function(c){
      var partes = c.casa.split(' ');
      var titulo = partes.length > 1
        ? esc(partes.slice(0, -1).join(' ')) + ' <em>' + esc(partes[partes.length-1]) + '</em>'
        : '<em>' + esc(c.casa) + '</em>';
      var n = c.skus.length;
      var propio = ' ' + c.clave + ' a-' + c.aire + ' t-' + c.trama;
      var vars = ' style="--t:' + c.tinta + ';--c:' + c.color + ';--l:' + c.contra + '"';
      return '<section class="pv5-casa' + propio + '" id="' + pref + c.id + '"' + vars + '>' +
        '<div class="pv5-fondo"><span class="pv5-fcolor"></span><span class="pv5-ftrama"></span><span class="pv5-fluz"></span></div>' +
        '<div class="pv5-adentro">' +
          '<div class="pv5-cab"><div class="pv5-origen">' + esc(c.origen) + '</div>' +
            '<h2>' + titulo + '</h2>' +
            '<p class="pv5-linea">' + esc(c.linea) + '</p>' +
            '<span class="pv5-cuantas">' + n + (n === 1 ? ' fragancia' : ' fragancias') + '</span></div>' +
          '<div class="pv5-piezas">' + c.skus.map(function(sk){
            var x = porSku(sk); return x ? fichaDeck(c, x) : ''; }).join('') + '</div>' +
        '</div>' +
        '<p class="pv5-pie">Velantis no está asociada con ' + esc(c.casa) + ' ni guarda relación ' +
        'comercial con esa firma. Su marca se menciona únicamente como referencia olfativa; ' +
        'Velantis elabora perfumes de inspiración.</p>' +
      '</section>';
    }).join('');
    return '<div class="pv5-pila">' + bandas + '</div>';
  }

  /* Las tiras ya no son diapositivas: cada casa marca su ficha del centro igual que el
     carrusel de la landing, para que las notas se abran al llegar. */
  function pilaViva(){
    Array.prototype.forEach.call(document.querySelectorAll('.pv5-pila .pv5-piezas'), function(t){
      ejeVivo(t, '.pv5-p');
    });
  }

  /* ------------------------------------------------- el catalogo de las veinte
     La tarjeta del sitio, en azul, para que la pagina de preventa termine en algo
     que ya se sabe usar. El buscador va flotando: aparece cuando el bloque esta a
     la vista y se va cuando no. */
  function tarjetaCat(x){
    var ella = x.cat === 'Para ella';
    return '<article class="pv5-cc' + (ella ? ' ella' : '') + '" data-sku="' + esc(x.sku) + '"' +
      ' data-b="' + esc(plano(x.nombre + ' ' + x.casa + ' ' + x.grupo + ' ' + x.sku + ' ' + x.olor)) + '"' +
      ' data-cat="' + esc(x.cat) + '" data-fam="' + esc(x.grupo) + '">' +
      '<button class="pv5-cc-cara" type="button" data-ver="' + esc(x.sku) + '">' +
        '<span class="pv5-cc-esc">' + imagenProducto(x) + '</span>' +
        '<span class="pv5-cc-top"><span class="pv5-cc-fam">' + esc(x.grupo) + '</span><span class="pv5-cc-para">' + esc(x.cat) + '</span></span>' +
        '<span class="pv5-cc-code">' + esc(x.sku) + '</span>' +
        '<span class="pv5-cc-ins">Inspirado en</span>' +
        '<span class="pv5-cc-nom">' + esc(x.nombre) + '</span>' +
        '<span class="pv5-cc-casa">de ' + esc(x.casa) + '</span>' +
        '<span class="pv5-cc-notas">' + esc(x.olor) + '</span>' +
        '<span class="pv5-cc-pre">' +
          '<span class="pz"><i>50 ml</i><b>' + pesos(precio(x.ruta, '50', x.p50)) + '</b></button>' +
          '<span class="pz"><i>100 ml</i><b>' + pesos(precio(x.ruta, '100', x.p100)) + '</b></button>' +
        '</span>' +
      '</button>' +
      (hayVariante(x.ruta, '100')
        ? '<button class="pv5-cc-add" type="button" data-add="' + esc(x.sku) + '">Agregar 100 ml</button>'
        : '<span class="pv5-cc-add sin">Muy pronto</span>') +
      '</article>';
  }

  /* La seccion «Las veinte, en lista» queda guardada por ahora: repetia en rejilla lo
     que las bandas de cada casa ya ensenan. Lo que sobrevive es su buscador, que ahora
     flota ARRIBA —no olvidado al pie— y filtra las fichas de las bandas.
     Su tarjeta queda en `tarjetaCat`, sin usar, por si la seccion se reactiva. */
  function barraHTML(){
    return '<div class="caja">' +
      '<span class="lupa" aria-hidden="true">&#9906;</span>' +
      '<input id="pv5Q" type="search" autocomplete="off"' +
      ' placeholder="Nombre, casa, código V o nota…" aria-label="Buscar entre los lanzamientos">' +
      '<button class="equis" id="pv5QX" type="button" aria-label="Limpiar la búsqueda">&times;</button>' +
      '<b id="pv5QN"></b></div>';
  }

  function buscadorVivo(){
    var caja = document.getElementById('pv5Busca');
    if(!caja){
      caja = document.createElement('div');
      caja.id = 'pv5Busca'; caja.className = 'pv5-buscaf fuera';
      document.body.appendChild(caja);
    }
    caja.innerHTML = barraHTML();
    var q = document.getElementById('pv5Q'), n = document.getElementById('pv5QN');
    var equis = document.getElementById('pv5QX');
    var pila = raiz.querySelector('.pv5-pila');
    if(!pila) return;
    var bandas = [].slice.call(pila.querySelectorAll('.pv5-casa'));

    function filtrar(){
      var t = plano(q.value.trim()), vistas = 0;
      caja.classList.toggle('con-texto', !!q.value.trim());
      bandas.forEach(function(b){
        var hay = 0;
        Array.prototype.forEach.call(b.querySelectorAll('.pv5-p'), function(f){
          var x = porSku(f.getAttribute('data-sku'));
          var blanco = x ? plano(x.nombre + ' ' + x.casa + ' ' + x.grupo + ' ' + x.sku + ' ' + x.olor + ' ' + x.cat) : '';
          var ok = !t || (x && window.VelantisBusqueda ? VelantisBusqueda.coincidencia(t,{sku:x.sku,nombre:x.nombre,casa:x.casa,texto:blanco}) > 0 : blanco.indexOf(t) >= 0);
          f.hidden = !ok; if(ok) hay++;
        });
        b.hidden = t && !hay;
        vistas += hay;
      });
      n.textContent = vistas + (vistas === 1 ? ' fragancia' : ' fragancias');
    }
    q.addEventListener('input', filtrar);
    equis.addEventListener('click', function(){ q.value = ''; filtrar(); q.focus(); });
    filtrar();

    /* La barra se ve mientras la pagina de preventa esta abierta y se aparta hacia
       arriba mientras se lee una ficha. */
    function ver(){
      var enPreventa = /^#\/preventa\/?$/.test(location.hash || '');
      var panel = document.getElementById('pv5Panel');
      var leyendo = panel && panel.classList.contains('on');
      caja.classList.toggle('fuera', !enPreventa || leyendo);
    }

    /* Y se coloca DEBAJO de lo que el sitio tenga pegado arriba —el anuncio y el
       encabezado—: puesta en top:0 les caia encima y tapaba el menu. Se mide en vivo
       porque el encabezado del sitio se encoge al bajar. */
    /* El encabezado de este tema es `sticky` pero no se queda pegado: se va con el
       scroll. Asi que no basta con mirar si esta fijo; lo que importa es si ahora mismo
       ocupa la parte de arriba de la pantalla. Si su borde inferior es positivo, la
       barra baja hasta el; si ya salio, la barra sube al tope. */
    var techo = ['header', '.topbar', '#shopify-section-header']
      .map(function(sel){ return document.querySelector(sel); })
      .filter(function(e, i, a){ return e && a.indexOf(e) === i; });
    var pedido = false;
    function bajar(){
      pedido = false;
      var y = 0;
      techo.forEach(function(e){
        var r = e.getBoundingClientRect();
        if(r.height && r.height < 260 && r.top < 170 && r.bottom > y) y = r.bottom;
      });
      caja.style.setProperty('--bajo', Math.max(0, Math.round(Math.min(y, 220))) + 'px');
    }
    window.addEventListener('scroll', function(){
      if(pedido) return; pedido = true; requestAnimationFrame(bajar); }, {passive:true});
    window.addEventListener('resize', function(){ requestAnimationFrame(bajar); }, {passive:true});
    bajar();

    window.addEventListener('hashchange', ver);
    window.__pv5VerBarra = ver;
    ver();
  }

  function tarjetaCat(x){
    var ella = x.cat === 'Para ella';
    return '<article class="pv5-cc' + (ella ? ' ella' : '') + '" data-sku="' + esc(x.sku) + '"' +
      ' data-b="' + esc(plano(x.nombre + ' ' + x.casa + ' ' + x.grupo + ' ' + x.sku + ' ' + x.olor)) + '"' +
      ' data-cat="' + esc(x.cat) + '" data-fam="' + esc(x.grupo) + '">' +
      '<button class="pv5-cc-cara" type="button" data-ver="' + esc(x.sku) + '">' +
        '<span class="pv5-cc-esc">' + imagenProducto(x) + '</span>' +
        '<span class="pv5-cc-nom">' + esc(x.nombre) + '</span>' +
      '</button></article>';
  }

  /* ------------------------------------------------------------- el panel */
  function abrir(x){
    if(!x) return;
    cur = x; talla = null;
    var q = function(id){ return document.getElementById(id); };
    q('pv5PCasa').textContent = 'Inspirado en';
    q('pv5PNom').textContent = x.nombre;
    q('pv5PDe').textContent = 'de ' + x.casa + ' · ' + x.cat;
    q('pv5POlor').textContent = x.olor;
    q('pv5PHist').innerHTML = [['Salió', x.estreno], ['Se presentó', x.donde], ['Busca', x.enaltece]]
      .map(function(f){ return '<div><dt>' + f[0] + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('');
    q('pv5PPir').innerHTML = [['Salida', x.salida], ['Corazón', x.corazon], ['Fondo', x.fondo]]
      .filter(function(f){ return f[1]; })
      .map(function(f){ return '<div><dt>' + f[0] + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('');
    var t100 = q('pv5T100'), t50 = q('pv5T50');
    /* mismo criterio que las pastillas: manda el precio que trae la pieza, que se toma
       de la tienda al generar la sección y no depende de que un mapa haya cargado */
    var h100 = x.p100 > 0 || hayVariante(x.ruta, '100'), h50 = x.p50 > 0 || hayVariante(x.ruta, '50');
    t100.querySelector('b').textContent = h100 ? pesos(precio(x.ruta, '100', x.p100)) : 'No disponible';
    t50.querySelector('b').textContent  = h50  ? pesos(precio(x.ruta, '50',  x.p50))  : 'No disponible';
    t100.disabled = !h100; t50.disabled = !h50;
    t100.setAttribute('aria-pressed','false'); t50.setAttribute('aria-pressed','false');
    var cta = q('pv5Cta');
    cta.disabled = true;
    cta.textContent = (h100 || h50) ? 'Elige el tamaño' : 'Aún no se puede apartar';
    q('pv5Nota').textContent = (h100 || h50)
      ? 'Lo apartas hoy y lo recoges desde el 20 de septiembre en Colosio 315.'
      : 'Esta pieza todavía no está dada de alta en la tienda. Pregúntala en el mostrador.';
    q('pv5Legal').textContent = 'Precio de tienda. Velantis elabora perfumes de inspiración: no está afiliada a la casa ' + x.casa + '.';
    q('pv5Velo').classList.add('on'); q('pv5Panel').classList.add('on');
    if(window.__pv5VerBarra) window.__pv5VerBarra();
  }
  function cerrar(){
    var v = document.getElementById('pv5Velo'), p = document.getElementById('pv5Panel');
    if(v) v.classList.remove('on'); if(p) p.classList.remove('on');
    if(window.__pv5VerBarra) window.__pv5VerBarra();
  }

  /* La unica puerta al carrito. Se usa el del sitio a proposito: ahi viven las
     promociones —el envio gratis desde $999 y el frasco de bolsillo de 30 ml con
     dos de 100 ml— y se aplican solas al agregar. */
  function alCarrito(x, t, boton){
    if(!x || !window.VelantisCart || !window.VelantisCart.add) return;
    if(!hayVariante(x.ruta, t)) return;
    window.VelantisCart.add({ talla: t, name: x.ruta,
      price: precio(x.ruta, t, t === '50' ? x.p50 : x.p100),
      img: 'n-' + familia(x.ruta), sub: x.casa });
    if(boton){
      var antes = boton.textContent;
      boton.classList.add('hecho'); boton.textContent = '✓';
      setTimeout(function(){ boton.classList.remove('hecho'); boton.textContent = antes; }, 1600);
    }
  }

  function panelHTML(){
    return '<div class="pv5-velo" id="pv5Velo"></div>' +
      '<aside class="pv5-panel" id="pv5Panel" role="dialog" aria-modal="true" aria-labelledby="pv5PNom">' +
        '<div class="pv5-tirador"></div>' +
        '<p class="pv5-pcasa" id="pv5PCasa"></p><h3 id="pv5PNom"></h3>' +
        '<p class="pv5-pde" id="pv5PDe"></p>' +
        '<p class="pv5-polor" id="pv5POlor"></p>' +
        '<dl class="pv5-hist" id="pv5PHist"></dl><dl class="pv5-pir" id="pv5PPir"></dl>' +
        '<div class="pv5-tallas">' +
          '<button class="pv5-talla" id="pv5T100" data-t="100" type="button" aria-pressed="false"><span>100 ml</span><b></b></button>' +
          '<button class="pv5-talla" id="pv5T50" data-t="50" type="button" aria-pressed="false"><span>50 ml</span><b></b></button>' +
        '</div>' +
        '<button class="pv5-cta" id="pv5Cta" type="button" disabled></button>' +
        '<p class="pv5-nota" id="pv5Nota"></p><p class="pv5-legal" id="pv5Legal"></p>' +
      '</aside>';
  }

  /* El panel vive colgado del <body> y es UNO solo: lo usan la landing y la pagina de
     preventa. Antes se pintaba dentro de #pv5 y solo existia en #/preventa, asi que en
     la landing un clic en una ficha no tenia donde abrir. */
  var panelListo = false;
  function asegurarPanel(){
    if(panelListo) return;
    if(!document.getElementById('pv5Panel')){
      var caja = document.createElement('div');
      caja.id = 'pv5PanelRaiz'; caja.className = 'pv5x';
      caja.innerHTML = panelHTML();
      document.body.appendChild(caja);
    }
    conectarPanel();
    panelListo = true;
  }

  function conectarPanel(){
    document.getElementById('pv5Velo').addEventListener('click', cerrar);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') cerrar(); });
    Array.prototype.forEach.call(document.querySelectorAll('#pv5Panel .pv5-talla'), function(t){
      t.addEventListener('click', function(){
        if(t.disabled) return;
        talla = t.getAttribute('data-t');
        Array.prototype.forEach.call(document.querySelectorAll('#pv5Panel .pv5-talla'), function(o){
          o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
        var cta = document.getElementById('pv5Cta');
        cta.disabled = false; cta.textContent = 'Agregar al carrito';
      });
    });
    document.getElementById('pv5Cta').addEventListener('click', function(){
      if(!talla || !cur) return;
      alCarrito(cur, talla); cerrar();
    });
  }

  /* La pagina individual de producto del sitio, por su ruta `#/p/<nombre>`.
     El nombre que esa ruta espera es el del catalogo vivo, no el nuestro: se busca por
     SKU en window.VELANTIS_CAT, que es donde vive el nombre bueno. Si no aparece, se
     cae al panel de siempre y no se pierde el clic. */
  function abrirPaginaProducto(x){
    if(!x) return false;
    var CAT = window.VELANTIS_CAT || [], nom = null;
    for(var i = 0; i < CAT.length; i++){
      if(CAT[i][12] === x.sku){ nom = CAT[i][0]; break; }
    }
    if(!nom) return false;
    if(window.VelantisProducto && window.VelantisProducto.open){
      window.VelantisProducto.open(nom); return true;
    }
    location.hash = '#/p/' + encodeURIComponent(nom);
    return true;
  }

  /* clics: el boton redondo va al carrito, la cara abre la pagina de producto */
  function conectarClics(nodo, enLanding){
    /* 17-sep: esto se llamaba dos veces sobre el mismo nodo, asi que cada clic agregaba DOS
       piezas al carrito (un solo toque, dos renglones de cantidad). La marca lo impide. */
    if(!nodo || nodo.getAttribute('data-clics') === '1') return;
    nodo.setAttribute('data-clics', '1');
    nodo.addEventListener('click', function(e){
      /* 17-sep, la casa: la pastilla ELIGE la version y el boton agrega lo elegido, igual que
         en el catalogo y en la ficha. Antes la pastilla agregaba de golpe y el boton mandaba
         siempre los 100 ml, asi que quien elegia 50 y luego pulsaba terminaba con dos. */
      var addt = e.target.closest('[data-addt]');
      if(addt){
        e.preventDefault(); e.stopPropagation();
        if(e.stopImmediatePropagation) e.stopImmediatePropagation();
        var par = String(addt.getAttribute('data-addt')).split('|');
        var ficha = addt.closest('.pv5t-f, .pv5-p') || addt.parentNode;
        [].forEach.call(ficha.querySelectorAll('.pz'), function(p){ p.classList.remove('pz-sel'); p.setAttribute('aria-pressed','false'); });
        addt.classList.add('pz-sel'); addt.setAttribute('aria-pressed','true');
        ficha.setAttribute('data-tl-sel', par[1] === '50' ? '50' : '100');
        return;
      }
      var add = e.target.closest('[data-add]');
      if(add){
        e.preventDefault(); e.stopPropagation();
        if(e.stopImmediatePropagation) e.stopImmediatePropagation();
        var f2 = add.closest('.pv5t-f, .pv5-p');
        var tl = (f2 && f2.getAttribute('data-tl-sel')) || '100';
        alCarrito(porSku(add.getAttribute('data-add')), tl, add);
        return;
      }
      /* La ficha entera abre la pagina del producto, no solo el texto del pie: tocar la
         imagen no hacia nada (comentario 15-sep). En escritorio, el clic sobre una ficha
         que no esta al centro ya lo detiene la pista antes de llegar aqui: la centra. */
      var ver = e.target.closest('[data-ver]') || e.target.closest('.pv5t-f[data-sku]');
      if(!ver) return;
      e.preventDefault();
      var x = porSku(ver.getAttribute('data-ver') || ver.getAttribute('data-sku'));
      if(!abrirPaginaProducto(x)) abrir(x);
    });
  }

  function encender(nodo){
    var f = nodo.querySelectorAll('.pv5-p, .pv5-cc');
    if(!('IntersectionObserver' in window)){
      Array.prototype.forEach.call(f, function(e){ e.classList.add('dentro'); }); return;
    }
    if(obs) obs.disconnect();
    obs = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('dentro'); obs.unobserve(e.target); } });
    }, {rootMargin:'0px 30% 0px 30%', threshold:.08});
    Array.prototype.forEach.call(f, function(e){ obs.observe(e); });
  }

  /* ------------------------------------------------------- la seccion #/preventa */
  var pintado = false;
  function pintarSeccion(){
    if(pintado || !raiz) return;
    if(!datos()) return;
    var C = CFG.comercial.seccion;
    raiz.innerHTML =
      '<a class="pv5-volver" href="#/">&larr; Volver al inicio</a>' +
      '<section class="pv5-hero">' +
        '<div class="pv5-hero-txt">' +
          '<div class="pv5-ante">' + esc(C.ante) + '</div>' +
          '<h1 id="pv5Titulo">' + C.titulo + '</h1>' +
          '<p class="pv5-hero-p">' + esc(C.dato) + '</p>' +
          '<div class="pv5-cuenta" id="pv5Cuenta"></div>' +
        '</div>' +
        '<div class="pv5-hero-foto"><img src="' + esc(CFG.foto) + '"' +
          ' alt="Velantis Elixir de Parfum" loading="eager" decoding="async"></div>' +
      '</section>' +
      pilaHTML() +
      '<section class="pv5-cierre">' +
        '<p>Lo apartas hoy · lo recoges en <b>Colosio 315, Hermosillo</b> desde el 20 de septiembre</p>' +
        '<p class="pv5-aviso">Velantis elabora perfumes de inspiración. No está afiliada a las casas mencionadas; sus marcas son de sus titulares y se citan como referencia olfativa.</p>' +
      '</section>';

    reloj(document.getElementById('pv5Cuenta'), document.getElementById('pv5Titulo'));
    pilaViva(); asegurarPanel(); conectarClics(raiz, false); encender(raiz); buscadorVivo();
    pintado = true;
    llevar();
  }

  /* Si se entró tocando una ficha del deck de la landing, aqui se va a la casa de esa
     fragancia y se abre su panel. */
  function llevar(){
    var sku = window.__pv5Ir; window.__pv5Ir = null;
    if(!sku || !raiz) return;
    var b = raiz.querySelector('.pv5-pila .pv5-p[data-sku="' + sku + '"]');
    if(!b) return;
    var casa = b.closest('.pv5-casa');
    if(casa) casa.scrollIntoView({block:'start'});
    Array.prototype.forEach.call(raiz.querySelectorAll('.pv5-p'), function(e){ e.classList.add('dentro'); });
    setTimeout(function(){ asegurarPanel(); abrir(porSku(sku)); }, 420);
  }

  /* ----------------------------------------------------------- la landing
     El carrusel oscuro: una sola superficie de noche, las veinte fichas corriendo de
     lado, la del centro un poco levantada y con las notas abiertas. El fondo ya no
     cambia con la casa —eso era la «division»—. Un clic abre la ficha aqui mismo; el
     boton del pie lleva a la pagina de preventa. */

  /* R47: the launch card shares the light house identity used by the comparator. */
  var ASOMO_IDENTITIES={"bondno9": {"house": "Bond No. 9", "pattern": "t-reglas", "light": "a-corte", "base": "#FCF1F4", "accent": "#D14B6A", "contrast": "#101018"}, "byredo": {"house": "Byredo", "pattern": "t-lino", "light": "a-papel", "base": "#EFEDE7", "accent": "#5A5A55", "contrast": "#1D1E1B"}, "carolinaherrera": {"house": "Carolina Herrera", "pattern": "t-lunares", "light": "a-seda", "base": "#F4F1EC", "accent": "#C41230", "contrast": "#1A1418"}, "chanel": {"house": "Chanel", "pattern": "t-acolchado", "light": "a-laca", "base": "#FDFDFC", "accent": "#E8E4DC", "contrast": "#0B0B0B"}, "dior": {"house": "Dior", "pattern": "t-cannage", "light": "a-perla", "base": "#E8E4DB", "accent": "#7E6317", "contrast": "#232529"}, "giorgioarmani": {"house": "Giorgio Armani", "pattern": "t-lino", "light": "a-barrido", "base": "#DBD7CE", "accent": "#5C6875", "contrast": "#1B1D20"}, "jomalone": {"house": "Jo Malone", "pattern": "t-lino", "light": "a-papel", "base": "#F0EDE4", "accent": "#6E6A2E", "contrast": "#20211C"}, "kayali": {"house": "Kayali", "pattern": "t-facetas", "light": "a-perla", "base": "#F9F2F8", "accent": "#C9A227", "contrast": "#1A0F1E"}, "lelabo": {"house": "Le Labo", "pattern": "t-hilvan", "light": "a-papel", "base": "#EDEAE2", "accent": "#4A4A46", "contrast": "#1C1C1A"}, "louisvuitton": {"house": "Louis Vuitton", "pattern": "t-damero", "light": "a-barrido", "base": "#F8F2E7", "accent": "#C8A24A", "contrast": "#1B1208"}, "maisonfranciskurkdjian": {"house": "Maison Francis Kurkdjian", "pattern": "t-cannage", "light": "a-perla", "base": "#EDEAE0", "accent": "#7A6A3E", "contrast": "#1F211C"}, "mancera": {"house": "Mancera", "pattern": "t-heraldica", "light": "a-metal", "base": "#FAF5E9", "accent": "#B98A3B", "contrast": "#12100A"}, "montale": {"house": "Montale", "pattern": "t-cordon", "light": "a-metal", "base": "#F5F8FB", "accent": "#7FA8C9", "contrast": "#0A0F14"}, "parfumsdemarly": {"house": "Parfums de Marly", "pattern": "t-heraldica", "light": "a-heraldo", "base": "#F2F5FA", "accent": "#C8A96A", "contrast": "#0D1B33"}, "valentino": {"house": "Valentino", "pattern": "t-tachas", "light": "a-seda", "base": "#FCF2F3", "accent": "#C8102E", "contrast": "#14060B"}, "xerjoff": {"house": "Xerjoff", "pattern": "t-facetas", "light": "a-perla", "base": "#F6F1FA", "accent": "#B08CC9", "contrast": "#0E0B12"}, "yvessaintlaurent": {"house": "Yves Saint Laurent", "pattern": "t-reglas", "light": "a-laca", "base": "#FAF6E9", "accent": "#D4A017", "contrast": "#0B0B0C"}, "abercrombiefitch": {"house": "Abercrombie & Fitch", "pattern": "t-cordon", "light": "a-marea", "base": "#EEF1F0", "accent": "#4A6A72", "contrast": "#1A1E1F"}, "amouage": {"house": "Amouage", "pattern": "t-arabesco", "light": "a-heraldo", "base": "#F7F5EB", "accent": "#C9A227", "contrast": "#0B1418"}, "arianagrande": {"house": "Ariana Grande", "pattern": "t-lunares", "light": "a-perla", "base": "#F8F2FA", "accent": "#D6B9E3", "contrast": "#9D7DB0"}, "armaf": {"house": "Armaf", "pattern": "t-vetas", "light": "a-bruma", "base": "#F8F3EB", "accent": "#A67C4A", "contrast": "#14100B"}, "azzaro": {"house": "Azzaro", "pattern": "t-reglas", "light": "a-marea", "base": "#F1F7FB", "accent": "#4A8CC2", "contrast": "#0A0E14"}, "bdkparfums": {"house": "BDK Parfums", "pattern": "t-vetas", "light": "a-bruma", "base": "#F8F3EB", "accent": "#A67C4A", "contrast": "#14100B"}, "bharara": {"house": "Bharara", "pattern": "t-facetas", "light": "a-metal", "base": "#F9F5ED", "accent": "#B08C4A", "contrast": "#0C0C10"}, "burberry": {"house": "Burberry", "pattern": "t-cuadros", "light": "a-niebla", "base": "#F7F1E7", "accent": "#7A5C2E", "contrast": "#2A2620"}, "bvlgari": {"house": "Bvlgari", "pattern": "t-facetas", "light": "a-perla", "base": "#F5F7F8", "accent": "#C9A227", "contrast": "#0F1418"}, "cacharel": {"house": "Cacharel", "pattern": "t-rosa", "light": "a-seda", "base": "#F2EDE9", "accent": "#B0416E", "contrast": "#1F1B1D"}, "creed": {"house": "Creed", "pattern": "t-heraldica", "light": "a-heraldo", "base": "#F1F6F1", "accent": "#9BB6A0", "contrast": "#101C18"}, "dolcegabbana": {"house": "Dolce & Gabbana", "pattern": "t-vetas", "light": "a-bruma", "base": "#F8F3EB", "accent": "#A67C4A", "contrast": "#14100B"}, "escentricmolecules": {"house": "Escentric Molecules", "pattern": "t-cordon", "light": "a-papel", "base": "#EDEDEA", "accent": "#4A4A4A", "contrast": "#1A1A1A"}, "ferragamo": {"house": "Ferragamo", "pattern": "t-rosa", "light": "a-seda", "base": "#F2EDE9", "accent": "#9C4A66", "contrast": "#1F1B1D"}, "giardiniditoscana": {"house": "Giardini di Toscana", "pattern": "t-yeso", "light": "a-bruma", "base": "#EDE1CD", "accent": "#A05423", "contrast": "#2B2519"}, "givenchy": {"house": "Givenchy", "pattern": "t-reglas", "light": "a-laca", "base": "#FAF2F5", "accent": "#C08496", "contrast": "#0B0B0C"}, "gucci": {"house": "Gucci", "pattern": "t-rayas", "light": "a-seda", "base": "#F3F7F1", "accent": "#B5121B", "contrast": "#12241B"}, "hermes": {"house": "Hermès", "pattern": "t-cuero", "light": "a-bruma", "base": "#F2E4D0", "accent": "#B5551E", "contrast": "#221E18"}, "isseymiyake": {"house": "Issey Miyake", "pattern": "t-cordon", "light": "a-marea", "base": "#E6EDF0", "accent": "#3E6A82", "contrast": "#181E22"}, "jeanpaulgaultier": {"house": "Jean Paul Gaultier", "pattern": "t-marinera", "light": "a-marea", "base": "#EFEDE7", "accent": "#1B3A6B", "contrast": "#171C24"}, "juicycouture": {"house": "Juicy Couture", "pattern": "t-rosa", "light": "a-seda", "base": "#F2EDE9", "accent": "#B0416E", "contrast": "#1F1B1D"}, "lancome": {"house": "Lancôme", "pattern": "t-rosa", "light": "a-seda", "base": "#F2EDEA", "accent": "#A83C68", "contrast": "#1E1A1C"}, "lattafa": {"house": "Lattafa", "pattern": "t-facetas", "light": "a-perla", "base": "#FCF2F3", "accent": "#CE8A9C", "contrast": "#160F0A"}, "loewe": {"house": "Loewe", "pattern": "t-cuero", "light": "a-bruma", "base": "#EFEAE0", "accent": "#8A6A3C", "contrast": "#20211D"}, "maisoncrivelli": {"house": "Maison Crivelli", "pattern": "t-cuero", "light": "a-niebla", "base": "#F7F3EF", "accent": "#8C6039", "contrast": "#100C0A"}, "maisonmartinmargiela": {"house": "Maison Martin Margiela", "pattern": "t-hilvan", "light": "a-papel", "base": "#F2F0EB", "accent": "#66625A", "contrast": "#22231F"}, "marcjacobs": {"house": "Marc Jacobs", "pattern": "t-lunares", "light": "a-papel", "base": "#F2EEE8", "accent": "#B0567E", "contrast": "#1F1B1E"}, "montblanc": {"house": "Montblanc", "pattern": "t-reglas", "light": "a-laca", "base": "#FCFCFB", "accent": "#D8D4CB", "contrast": "#0C0C0E"}, "moschino": {"house": "Moschino", "pattern": "t-lunares", "light": "a-seda", "base": "#F4EFE6", "accent": "#C4342E", "contrast": "#1E1A18"}, "mugler": {"house": "Mugler", "pattern": "t-facetas", "light": "a-metal", "base": "#F0F7FB", "accent": "#5FA8D3", "contrast": "#080D14"}, "narcisorodriguez": {"house": "Narciso Rodriguez", "pattern": "t-lino", "light": "a-papel", "base": "#F0ECE6", "accent": "#A0606E", "contrast": "#1D1B19"}, "ortoparisi": {"house": "Orto Parisi", "pattern": "t-cordon", "light": "a-metal", "base": "#F6F6F6", "accent": "#8C8C8C", "contrast": "#0A0A0A"}, "pacorabanne": {"house": "Paco Rabanne", "pattern": "t-discos", "light": "a-metal", "base": "#F5F4EE", "accent": "#CBB26A", "contrast": "#0D0F14"}, "prada": {"house": "Prada", "pattern": "t-cordon", "light": "a-nailon", "base": "#F2F8F5", "accent": "#5FA383", "contrast": "#0C1310"}, "ralphlauren": {"house": "Ralph Lauren", "pattern": "t-rayas", "light": "a-barrido", "base": "#F2F5FA", "accent": "#BC8898", "contrast": "#0B1220"}, "room1015": {"house": "Room 1015", "pattern": "t-lunares", "light": "a-sol", "base": "#F4EDE6", "accent": "#B0562E", "contrast": "#201B18"}, "soldejaneiro": {"house": "Sol de Janeiro", "pattern": "t-yeso", "light": "a-sol", "base": "#F5E6CE", "accent": "#D0708A", "contrast": "#241E16"}, "thomaskosmala": {"house": "Thomas Kosmala", "pattern": "t-lino", "light": "a-sol", "base": "#F0F0E4", "accent": "#6E7A2E", "contrast": "#1C1E18"}, "tomford": {"house": "Tom Ford", "pattern": "t-vetas", "light": "a-laca", "base": "#F5F3EF", "accent": "#C6A664", "contrast": "#0A0A0A"}, "versace": {"house": "Versace", "pattern": "t-greca", "light": "a-laca", "base": "#FAF7EC", "accent": "#D4AF37", "contrast": "#0B0B0B"}, "viktorrolf": {"house": "Viktor & Rolf", "pattern": "t-facetas", "light": "a-perla", "base": "#F7F3FA", "accent": "#C9A227", "contrast": "#0E0A14"}, "rabanne": {"house": "Paco Rabanne", "pattern": "t-discos", "light": "a-metal", "base": "#F5F4EE", "accent": "#CBB26A", "contrast": "#0D0F14"}, "hugoboss": {"house": "Hugo Boss", "pattern": "t-reglas", "light": "a-papel", "base": "#F8F6F2", "accent": "#A88960", "contrast": "#292D2C"}, "initioparfumsprives": {"house": "Initio Parfums Privés", "pattern": "t-cordon", "light": "a-metal", "base": "#F9F7F6", "accent": "#B0A08C", "contrast": "#0A0A0D"}, "jomalonelondon": {"house": "Jo Malone", "pattern": "t-lino", "light": "a-papel", "base": "#F0EDE4", "accent": "#6E6A2E", "contrast": "#20211C"}, "maisonmargiela": {"house": "Maison Martin Margiela", "pattern": "t-hilvan", "light": "a-papel", "base": "#F2F0EB", "accent": "#66625A", "contrast": "#22231F"}, "penhaligons": {"house": "Penhaligon's", "pattern": "t-heraldica", "light": "a-niebla", "base": "#F9F6EF", "accent": "#B08C3C", "contrast": "#0F1410"}};
  function identidadAsomo(x){
    var key=plano(x.casa).replace(/[^a-z0-9]/g,''),known=ASOMO_IDENTITIES[key];
    if(known)return known;
    var own=x.casaId||{};
    return {house:x.casa,pattern:'t-'+(/^[a-z-]+$/.test(own.trama||'')?own.trama:'reglas'),light:'a-'+(/^[a-z-]+$/.test(own.aire||'')?own.aire:'papel'),base:'#f8f6f2',accent:/^#[a-f0-9]{6}$/i.test(own.color||'')?own.color:'#a88960',contrast:'#24364c'};
  }
  function fondoAsomo(h){return '<span class="pv5t-identity claro '+esc(h.pattern)+' '+esc(h.light)+'" aria-hidden="true" style="--t:'+esc(h.base)+';--c:'+esc(h.accent)+';--l:'+esc(h.contrast)+'"><span class="pv5-ftrama"></span></span>';}


  /* R48: reuse the existing product-note artwork; bloom at its final position. */
  var notasAsomo=null,notasPromesa=null,notasObserver=null;
  function ponerNotasAsomo(){
    if(!asomo || !notasAsomo)return;
    if(notasObserver)notasObserver.disconnect();
    if('IntersectionObserver' in window)notasObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){entry.target.classList.toggle('pv48-bloom',entry.isIntersecting);});
    },{threshold:.4});
    var positions=[['12%','24%','-16deg'],['88%','43%','17deg'],['25%','87%','-9deg']];
    asomo.querySelectorAll('.pv5t-f').forEach(function(card){
      var mount=card.querySelector('.pv5t-medallon');
      if(!mount)return;
      if(!mount.querySelector('.pv48-notas')){
        var notes=(notasAsomo[card.getAttribute('data-sku')]||[]).slice(0,3);
        mount.insertAdjacentHTML('beforeend','<span class="pv48-notas" aria-hidden="true">'+notes.map(function(note,i){
          var pos=positions[i];
          return '<span class="pv48-orbita" data-nota="'+esc(note.name)+'" style="--nx:'+pos[0]+';--ny:'+pos[1]+';--g:'+pos[2]+';--d:'+i+'"><img class="pv48-nota" src="'+esc(note.src)+'" alt="" loading="lazy" decoding="async" draggable="false"></span>';
        }).join('')+'</span>');
        card.addEventListener('pointerenter',function(e){
          if(e.pointerType!=='mouse')return;
          card.classList.add('pv48-restart');
          card.classList.remove('pv48-bloom');
          void card.offsetWidth;
          requestAnimationFrame(function(){card.classList.remove('pv48-restart');card.classList.add('pv48-bloom');});
        });
      }
      if(notasObserver)notasObserver.observe(card);else card.classList.add('pv48-bloom');
    });
  }
  function cargarNotasAsomo(){
    if(notasAsomo){ponerNotasAsomo();return;}
    if(notasPromesa || !window.VELANTIS_LAUNCH_NOTES)return;
    notasPromesa=fetch(window.VELANTIS_LAUNCH_NOTES).then(function(response){
      if(!response.ok)throw new Error('No se pudieron cargar las notas de producto.');
      return response.json();
    }).then(function(data){notasAsomo=data;ponerNotasAsomo();}).catch(function(){notasPromesa=null;});
  }

  function fichaAsomo(x){
    var identidad=identidadAsomo(x);
    /* La distincion de hombre y mujer va con el acento femenino de la propia casa, no
       con un rosa generico: es la misma regla que usan las fichas de #/preventa. */
    var ella = x.cat === 'Para ella' && x.casaId && x.casaId.femenino;
    var gen = x.para === 'Para ella' ? 'ella' : (x.para === 'Unisex' ? 'unisex' : 'el');
    return '<article class="pv5t-f' + (ella ? ' ella' : '') + '" data-sku="' + esc(x.sku) + '" data-house="'+esc(identidad.house)+'" data-house-pattern="'+esc(identidad.pattern)+'" style="--pv47-base:'+esc(identidad.base)+(ella ? ';--c:'+esc(x.casaId.femenino) : '')+'">' + fondoAsomo(identidad) + '<span class="pv5t-cod">' + esc(x.sku) + '</span>' +
      /* 15-sep (la casa): la foto es la de producto —el frasco con sus notas—, redonda,
         igual que las recomendaciones de la encuesta. Codigo V y «Inspirado en X · Casa»
         como en el catalogo, y el precio en las mismas pastillas, en TODAS las fichas. */
      '<span class="pv5t-e" style="--aura:' + esc(x.cat === 'Para ella' && x.casaId && x.casaId.femenino ? x.casaId.femenino : '#C9A55E') + '">' +
        '<span class="pv5t-medallon"><span class="pv5t-foto">' +
          (FOTOS[x.sku]
            /* la foto se ve a ~136 px en telefono y ~180 en escritorio: se pide de ese tamano,
               no de 560 (16-sep: la portada bajo de 13 MB a la mitad por cosas como esta) */
            ? '<img src="' + esc(FOTOS[x.sku]) + '&width=280" srcset="' + esc(FOTOS[x.sku]) + '&width=160 160w, ' +
              esc(FOTOS[x.sku]) + '&width=280 280w, ' + esc(FOTOS[x.sku]) + '&width=400 400w, ' + esc(FOTOS[x.sku]) + '&width=600 600w" sizes="(max-width:767px) 160px, (max-width:1166px) 18vw, 210px"' +
              ' alt="Velantis inspirado en ' + esc(x.nombre) + '" loading="lazy" decoding="async" draggable="false">'
            : '<img class="esc" src="' + esc(ESC[x.sku] || '') + '" alt="Notas de ' + esc(x.nombre) + '" loading="lazy" decoding="async" draggable="false">') +
        '</span></span>' +
        (hayVariante(x.ruta, '100')
          ? '<button class="pv5t-mas" type="button" data-add="' + esc(x.sku) + '"' +
            ' title="Agregar 100 ml al carrito" aria-label="Agregar ' + esc(x.nombre) + ' de 100 ml al carrito">+</button>'
          : '') +
      '</span>' +
      '<div class="pv5t-t" data-ver="' + esc(x.sku) + '">' +
        '<div class="pv5t-reading">' +

        '<span class="pv5t-inspired">Inspirado en</span><button class="pv5t-nom" type="button" data-ver="' + esc(x.sku) + '">' + esc(x.nombre) + '</button><span class="pv5t-house">' + esc(x.casa) + '</span>' +
        '<span class="pv5t-olor">' + esc(x.olor) + '</span>' +
        '</div>' +
        '<span class="pv5t-gen g-' + gen + '">' + esc(x.para || x.cat) + '</span>' +
        /* La casa (16-sep): «en todas que se pueda elegir entre las versiones». Cada
           pastilla agrega SU talla; el nombre dice qué hace, para quien no ve la pantalla. */
        /* El precio de 50 ml viaja con la pieza (viene de la tienda al generar la sección).
           Preguntarle al mapa o al carrito era una carrera perdida: si todavía no habían
           cargado, la pastilla no se pintaba y la fragancia se quedaba solo con los 100 ml
           (la casa, 16-sep: «cuántas veces te tengo que pedir que muestres los de 389»). */
        '<span class="price pv5t-pre" data-2p="' + (x.p50 > 0 ? '1' : 'no') + '">' +
          (x.p50 > 0
            ? '<button class="pz pz-50" type="button" aria-pressed="false" data-addt="' + esc(x.sku) + '|50"' +
              ' aria-label="Elegir ' + esc(x.nombre) + ' de 50 ml">' +
              '<i>50 ml</i><b>' + pesos(precio(x.ruta, '50', x.p50)) + '</b></button>' : '') +
          '<button class="pz pz-100" type="button" aria-pressed="false" data-addt="' + esc(x.sku) + '|100"' +
            ' aria-label="Elegir ' + esc(x.nombre) + ' de 100 ml">' +
            '<i>100 ml</i><b>' + pesos(precio(x.ruta, '100', x.p100)) + '</b></button>' +
        '</span>' +
      '</div></article>';
  }

  /* Marcar la pieza del centro de una tira. Lo usan el carrusel de la landing y las
     tiras de cada casa en #/preventa: es el mismo gesto —la del eje se levanta y abre
     sus notas— y por eso vive en un solo lugar. */
  function ejeVivo(pista, sel){
    var f = [].slice.call(pista.querySelectorAll(sel));
    if(!f.length) return null;
    function marcar(){
      var caja = pista.getBoundingClientRect(), medio = caja.left + caja.width / 2;
      var mejor = 0, cerca = Infinity;
      for(var i = 0; i < f.length; i++){
        var r = f[i].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - medio);
        if(d < cerca){ cerca = d; mejor = i; }
      }
      for(var j = 0; j < f.length; j++) f[j].classList.toggle('eje', j === mejor);
      return mejor;
    }
    pista.addEventListener('scroll', function(){
      clearTimeout(pista.__m); pista.__m = setTimeout(marcar, 70); }, {passive:true});
    marcar();
    return marcar;
  }

  function carruselVivo(){
    var pista = document.getElementById('pv5tPista');
    var ant = document.getElementById('pv5tAnt'), sig = document.getElementById('pv5tSig');
    if(!pista) return;
    var f = [].slice.call(pista.querySelectorAll('.pv5t-f'));
    if(!f.length) return;
    var paso = 0, eje = 0, quieto = false, reloj = null, arrancado = false;

    /* La vista minima es de TRES. El ancho de la ficha se calcula del hueco disponible;
       fijarlo en pixeles era lo que dejaba solo dos por debajo de 565 px. */
    function medir(){
      var w = pista.clientWidth; if(!w) return;
      /* En telefono, forzar tres dejaba fichas de 122 px y no se leia nada: van DOS.
         Siete en 1440 px dejaban tarjetas de 193 px, chicas para escritorio: van cinco. */
      var n = window.matchMedia('(max-width:767px)').matches ? 2 : 3;
      var hueco = w >= 900 ? 18 : 12;
      var ancho = (w - hueco * (n - 1)) / n;
      pista.style.setProperty('--anchoF', ancho + 'px');
      pista.style.setProperty('--hueco', hueco + 'px');
      pista.style.setProperty('--sangria', '0px');
      pista.dataset.visibleCards = String(n);
      paso = ancho + hueco;
      /* al medir por primera vez se arranca en la copia del medio */
      if(!arrancado){ arrancado = true; eje = Math.floor(f.length / 3) || 0; }
      pista.scrollLeft = eje * paso;
      marcar();
    }
    /* La tira lleva la lista TRES veces. Se arranca en la copia del medio y, cuando el
       visitante se acerca a un extremo, se salta una lista entera en seco: como las
       fichas son las mismas, el salto no se ve y el carrusel no tiene principio ni fin.
       Asi se acaba el hueco vacio del arranque. */
    var UNA = Math.floor(f.length / 3) || 1;

    function recolocar(){
      if(!paso || f.length < UNA * 3) return;
      if(eje < UNA * 0.5){ eje += UNA; pista.scrollLeft = eje * paso; }
      else if(eje > UNA * 2.5){ eje -= UNA; pista.scrollLeft = eje * paso; }
    }

    function marcar(){
      if(!paso) return;
      eje = Math.max(0, Math.min(f.length - 1, Math.round(pista.scrollLeft / paso)));
      recolocar();
      for(var i = 0; i < f.length; i++) f[i].classList.toggle('eje', i === eje);
      ant.disabled = false; sig.disabled = false;
    }
    function ir(i, seco){
      if(!paso) return;
      i = Math.max(0, Math.min(f.length - 1, i));
      /* si el destino cae fuera de la copia del medio, se recoloca antes de moverse */
      pista.scrollTo({left: i * paso, behavior: seco ? 'auto' : 'smooth'});
      eje = i; marcar();
    }
    pista.addEventListener('scroll', function(){
      clearTimeout(pista.__m); pista.__m = setTimeout(marcar, 80); }, {passive:true});
    ant.addEventListener('click', function(){ ir(eje - Number(pista.dataset.visibleCards || 3)); });
    sig.addEventListener('click', function(){ ir(eje + Number(pista.dataset.visibleCards || 3)); });

    /* Se arrastra con el dedo y con el raton. En escritorio el navegador arrancaba su
       propio arrastre de imagen y el gesto no llegaba nunca: de ahi el preventDefault y
       el dragstart cancelado. */
    var tirando = false, x0 = 0, s0 = 0, movio = 0, tUlt = 0, xUlt = 0, vel = 0;
    var cap = null, tocada = null, tragar = false, UMBRAL = 6;

    pista.addEventListener('pointerdown', function(e){
      /* En tactil NO se toca el gesto: lo lleva el navegador, con su inercia y su
         rebote. Arrastrar a mano desde JavaScript era lo que lo hacia sentir duro y
         poco deslizable en telefono. Aqui solo se recuerda que ficha se toco. */
      if(e.pointerType !== 'mouse'){ tocada = e.target.closest('.pv5t-f'); movio = 0; return; }
      if(e.button !== 0) return;
      tirando = true; movio = 0; vel = 0;
      x0 = xUlt = e.clientX; s0 = pista.scrollLeft; tUlt = e.timeStamp;
      /* Se apunta AQUI que ficha quedo debajo del dedo. En el `click` no se puede
         averiguar: al capturar el puntero, el navegador manda el clic a la pista y no a
         la tarjeta, asi que `e.target.closest('.pv5t-f')` salia nulo y no se centraba
         nada. (Mi prueba anterior disparaba el clic por codigo, que se salta toda la
         secuencia de puntero, y por eso paso.) */
      tocada = e.target.closest('.pv5t-f');
    });

    pista.addEventListener('pointermove', function(e){
      if(!tirando) return;
      var d = e.clientX - x0;
      if(Math.abs(d) > movio) movio = Math.abs(d);
      /* La captura se pide solo cuando el gesto YA es un arrastre. Pedirla desde el
         principio rompia el clic simple; pedirla tarde conserva las dos cosas: el clic
         nativo llega a su tarjeta y el arrastre sigue aunque el dedo salga de la tira. */
      if(movio > UMBRAL && cap === null){
        cap = e.pointerId;
        try{ pista.setPointerCapture(cap); }catch(err){}
        pista.classList.add('arrastra');
      }
      if(cap === null) return;
      var dt = e.timeStamp - tUlt;
      if(dt > 0){ vel = (e.clientX - xUlt) / dt; tUlt = e.timeStamp; xUlt = e.clientX; }
      pista.scrollLeft = s0 - d;
    });

    function soltar(){
      if(!tirando) return;
      tirando = false;
      var arrastro = cap !== null;
      if(arrastro){
        pista.classList.remove('arrastra');
        try{ pista.releasePointerCapture(cap); }catch(err){}
        cap = null;
        /* Inercia: un empujon rapido pasa varias fichas. */
        if(paso) ir(Math.round((pista.scrollLeft - vel * 170) / paso));
        vel = 0;
        return;
      }
      /* No fue arrastre, fue un toque. Si la ficha no esta al centro, se centra y no se
         abre nada; si ya estaba al centro, no se hace nada aqui y el clic sigue su
         camino hasta abrir la ficha. */
      /* R48: todas las tarjetas visibles responden al primer toque. */
    }
    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointercancel', soltar);
    pista.addEventListener('dragstart', function(e){ e.preventDefault(); });

    /* El clic solo se detiene; abrir la ficha se decide arriba, en `soltar`.
       Y se detiene por una BANDERA, no volviendo a mirar si la tarjeta esta al centro:
       para cuando llega el clic, `soltar` ya la centro y la clase `eje` ya esta puesta,
       asi que la condicion salia falsa y el panel se abria igual. */
    pista.addEventListener('click', function(e){
      if(e.target.closest('[data-add],[data-addt]')){ tragar = false; movio = 0; return; }
      if(tragar || movio > 8){ e.preventDefault(); e.stopPropagation(); }
      tragar = false; movio = 0;
    }, true);

    /* Gira sola cada 8 segundos; se detiene mientras se toca y con la pestana oculta. */
    function girar(){
      if(reloj) clearInterval(reloj);
      if(pista.__reloj) clearInterval(pista.__reloj);
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      pista.__reloj = reloj = setInterval(function(){
        if(quieto || tirando || document.hidden || !pista.clientWidth) return;
        ir(eje + 1);          /* no hay final al que rebotar: la tira se recoloca sola */
      }, 8000);
    }
    asomo.addEventListener('pointerenter', function(){ quieto = true; });
    asomo.addEventListener('pointerleave', function(){ quieto = false; });
    asomo.addEventListener('touchstart', function(){ quieto = true; }, {passive:true});
    asomo.addEventListener('touchend', function(){
      setTimeout(function(){ quieto = false; }, 5000); }, {passive:true});

    window.addEventListener('resize', function(){
      clearTimeout(pista.__r); pista.__r = setTimeout(medir, 180); }, {passive:true});
    medir();
    if(window.ResizeObserver){
      var ultimaAnchura = pista.clientWidth;
      pista.__ro = new ResizeObserver(function(){
        if(pista.clientWidth && pista.clientWidth !== ultimaAnchura){
          ultimaAnchura = pista.clientWidth;
          requestAnimationFrame(medir);
        }
      });
      pista.__ro.observe(pista);
    }
    /* El primer cuadro puede dar clientWidth 0 y entonces no hay ancho que repartir. */
    if(!pista.clientWidth) requestAnimationFrame(medir);
    girar();
  }

  /* ----------------------------------------------------- pre-filtro del carrusel
     La casa (16-sep): «pon botones de para ella, para él y unisex para que permita hacer
     un pre-filtro». La tira se vuelve a pintar con lo elegido; si una opción se quedara
     sin piezas se enseñan todas, antes que dejar el carrusel vacío. */
  var FILTROS_ASOMO = ['Todos', 'Para ella', 'Para \u00e9l', 'Unisex'], elegidoAsomo = 'Todos';

  function piezasDe(f){
    if(f === 'Todos') return CFG.piezas;
    var l = CFG.piezas.filter(function(x){ return x.para === f; });
    return l.length ? l : CFG.piezas;
  }
  /* la tira se pinta TRES veces: así el carrusel gira sin que se vea el principio */
  function tiraHTML(f){
    var l = piezasDe(f);
    return l.map(fichaAsomo).join('') + l.map(fichaAsomo).join('') + l.map(fichaAsomo).join('');
  }
  function filtrarAsomo(f){
    var vieja = document.getElementById('pv5tPista');
    if(!vieja) return;
    elegidoAsomo = f;
    if(vieja.__reloj){ clearInterval(vieja.__reloj); vieja.__reloj = null; }
    if(vieja.__ro) vieja.__ro.disconnect();
    /* un clon sin hijos se lleva las escuchas viejas: así no se acumulan */
    var nueva = vieja.cloneNode(false);
    nueva.innerHTML = tiraHTML(f);
    vieja.parentNode.replaceChild(nueva, vieja);
    var n = piezasDe(f).length, cuantas = document.getElementById('pv5tCuantas');
    if(cuantas) cuantas.textContent = n + (n === 1 ? ' fragancia' : ' fragancias');
    [].forEach.call(document.querySelectorAll('#pv5t .pv5t-fil'), function(b){
      var on = b.getAttribute('data-para') === f;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    carruselVivo();
    cargarNotasAsomo();
  }

  function pintarAsomo(){
    var route61=(location.hash.match(/^#\/([a-z-]+)/)||[])[1];if(SIN_ASOMO&&SIN_ASOMO[route61])return;
    if(!asomo || asomo.getAttribute('data-listo') === '1') return;
    if(!datos()) return;
    var C = CFG.comercial.asomo;
    asomo.innerHTML =
      '<span class="pv5t-vela" aria-hidden="true"></span>' +
      '<div class="pv5t-cab">' +
        '<div class="pv5t-txt">' +
          '<div class="pv5t-ante"><span>' + esc(C.ante) + '</span></div>' +
          '<h2>' + C.titulo + '</h2>' +
          '<p class="pv5t-linea">' + esc(String(C.linea||'').replace(/Ya los tenemos:[^<]*Colosio 315\.?/, '').trim()) + '</p>' +
          /* pre-filtro por para quien (16-sep): el carrusel se queda con lo que pidas */
          '<div class="pv5t-filtros" role="group" aria-label="Filtrar por para quien">' +
            FILTROS_ASOMO.map(function(f, i){
              return '<button class="pv5t-fil' + (i === 0 ? ' on' : '') + '" type="button" data-para="' +
                     esc(f) + '" aria-pressed="' + (i === 0) + '">' + esc(f) + '</button>';
            }).join('') +
            '<span class="pv5t-cuantas" id="pv5tCuantas"></span>' +
          '</div>' +
          '<p class="pv5t-scroll-hint">Desliza o usa las flechas para descubrir más fragancias</p>' +
        '</div>' +
      '</div>' +
      '<div class="pv5t-carril">' +
        /* La tira se pinta TRES veces: asi el carrusel es infinito y nunca se ve el
           hueco del principio, que era lo que se sentia vacio. */
        '<div class="pv5t-pista" id="pv5tPista">' + tiraHTML(elegidoAsomo) + '</div>' +
        '<button class="pv5t-nav izq" id="pv5tAnt" type="button" aria-label="Fragancia anterior"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5 8 12l7 7"/></svg></button>' +
        '<button class="pv5t-nav der" id="pv5tSig" type="button" aria-label="Fragancia siguiente"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>' +
      '</div>' +
      /* Sin pie: la casa pidio quitar la invitacion y los dos botones. El carrusel se
         entiende solo, y cada ficha ya lleva a su pagina de producto. */
      '';
    asomo.setAttribute('data-listo', '1');
    asegurarPanel();
    asomo.addEventListener('click', function(e){
      var b = e.target.closest('.pv5t-fil');
      if(!b) return;
      e.preventDefault(); e.stopPropagation();
      filtrarAsomo(b.getAttribute('data-para'));
    }, true);
    filtrarAsomo(elegidoAsomo);
    /* false: la ficha se abre AQUI, en la landing. Antes el clic saltaba a #/preventa. */
    conectarClics(asomo, false);
  }

  /* ------------------------------------------------------------- arranque */
  /* 18-sep, la casa: «en las secciones de dama, caballero y unisex quita por ahora la
     seccion de Estrena lo que acaba de salir». El router del sitio (index-12) solo sabe tapar
     el teaser viejo (#preventaTeaser), asi que el asomo nuevo se cuida solo: en esas tres
     colecciones se esconde, y al volver a la portada reaparece. */
  var SIN_ASOMO = {dama: 1, caballero: 1, unisex: 1, disenadores: 1, "encuentra-tu-aroma": 1};
  function asomoSegunRuta(){
    var caja = document.getElementById('pv5Teaser');
    if(!caja) return;
    var m = /^#\/([a-z-]+)/.exec(location.hash || '');
    caja.hidden = !!(m && SIN_ASOMO[m[1]]);if(!caja.hidden)pintarAsomo();
  }
  function ruta(){
    asomoSegunRuta();
    if(/^#\/preventa\/?$/.test(location.hash || '')){ pintarSeccion(); llevar(); }
    else cerrar();
  }
  window.addEventListener('hashchange', ruta);
  var espera = (window.MAPA_VIVO && window.MAPA_VIVO.listo) || Promise.resolve();
  espera.then(function(){
    if(pintado && raiz){ pintado = false; relojes = []; raiz.innerHTML = ''; pintarSeccion(); }
    if(asomo){ asomo.setAttribute('data-listo', '0'); relojes = []; pintarAsomo(); }
  });
  function arranque(){ pintarAsomo(); ruta(); }
  // Se sirve con defer: el DOM y los datos ya existen, sin otra espera.
  arranque();
  window.VELANTIS_PV5 = { pintar: pintarSeccion, asomo: pintarAsomo };
})();
